import React, { Component } from "react";
import Loading from "./Loading";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
export default class EducationHistoryUndergraduate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      undergradDegree: [],
      highSchoolCertificateData: [],
      highSchoolCertificate: "",
      degreeData: [],
      selectedDegree: "",
      educationGradeData: [],
      educationGrade: 0,
      grade: "",
      endDate: "",
      highSchoolNameData: [],
      highSchoolName: "",
      selectedCategory: "",
      perviousUniversity: "",
      selectedCountry: "",
      countryData: this.props.countryData,
      institutionName: "",
      perviousUniversityName: "",
      previousUniversityData: [],
      previousUniversityCertificate: "",
      previousUniversityGPA: "",
      marks: "",
    };
    this.addUnderGradDegree = this.addUnderGradDegree.bind(this);
    this.changeHighSchoolCerti = this.changeHighSchoolCerti.bind(this);
    this.getSchoolGrades = this.getSchoolGrades.bind(this);
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/EducationHistory/GetAllMajors`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          highSchoolCertificateData: res,
          highSchoolCertificate: "",
        });
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetDegrees`
        )
      )
      .then((res) => res.json())
      .then((res) => {
        if (res.length) {
          this.setState({ degreeData: res, selectedDegree: "" });
        }
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetUniversitiesName`
          // `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetCampus`
        )
      )
      .then((res) => res.json())
      .then((res) => {
        if (res.length) {
          this.setState({ highSchoolNameData: res, highSchoolName: "" });
        }
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetUniversitiesName`
        )
      )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          previousUniversityData: res,
          perviousUniversityName: "",
        });
      })
      .then(() => this.changeHighSchoolCerti(this.state.highSchoolCertificate))
      .then(() => {
        //console.log(this.props);
        if (this.props.educationHistory.length > 1) {
          const underGradDegree = [];
          this.props.educationHistory.forEach((element, index) => {
            let highSchoolName;
            let perviousUniversity;
            if (element.InstitutionId === "36") {
              highSchoolName = [{ Id: "36", value: element.InstitutionName }];
            } else {
              highSchoolName = this.state.highSchoolNameData.filter(
                (ele) => ele.Id === parseInt(element.InstitutionId)
              );
            }
            if (element.TranferedInstitutionId === "other") {
              perviousUniversity = [
                { Id: "other", value: element.TranferedInstitutionName },
              ];
            } else {
              perviousUniversity = this.state.previousUniversityData.filter(
                (ele) => ele.Id === parseInt(element.TranferedInstitutionId)
              );
            }
            let yearOfGraduation = "";
            if (element.EndDate) {
              const date = new Date(element.EndDate);
              let month = date.getMonth() + 1;
              let day = date.getDate();
              let year = date.getFullYear();
              if (month < 10) {
                month = "0" + month;
              }
              if (day < 10) {
                day = "0" + day;
              }
              if (year < 10) {
                year = "000" + year;
              } else if (year < 100) {
                year = "00" + year;
              } else if (year < 1000) {
                year = "0" + year;
              }
              yearOfGraduation = year + "-" + month + "-" + day;
            }
            if (index <= this.props.educationHistory.length - 2) {
              underGradDegree.push({
                highSchoolCertificate: element.CurriculumId,
                endDate: yearOfGraduation || "",
                highSchoolName:
                  highSchoolName && highSchoolName.length > 0
                    ? highSchoolName[0].Id
                    : "",
                selectedCountry: element.CountryId,
                grade: element.GradeId,
                perviousUniversity: perviousUniversity.length
                  ? perviousUniversity[0].Id
                  : "",
                institutionName:
                  highSchoolName && highSchoolName.length > 0
                    ? highSchoolName[0].value
                    : "123",
                perviousUniversityName:
                  perviousUniversity && perviousUniversity.length > 0
                    ? perviousUniversity[0].value
                    : "456",
                previousUniversityCertificate: element.TransferredCerti,
                previousUniversityGPA: element.TransferredGPA,
                mark: element.TotalMark,
                educationGrade: element.EducationGrade,
                selectedCategory: element.selectedCategory,
                selectedDegree: element.selectedDegree,
              });
            } else {
              this.setState({
                highSchoolCertificate: element.CurriculumId,
                endDate: yearOfGraduation || "",
                highSchoolName:
                  highSchoolName && highSchoolName.length > 0
                    ? highSchoolName[0].Id
                    : "",
                selectedCountry: element.CountryId,
                grade: element.GradeId,
                perviousUniversity: perviousUniversity.length
                  ? perviousUniversity[0].Id
                  : "",
                institutionName:
                  highSchoolName && highSchoolName.length > 0
                    ? highSchoolName[0].value
                    : "",
                perviousUniversityName:
                  perviousUniversity && perviousUniversity.length > 0
                    ? perviousUniversity[0].value
                    : "",
                previousUniversityCertificate: element.TransferredCerti,
                previousUniversityGPA: element.TransferredGPA,
                mark: element.TotalMark,
                educationGrade: element.EducationGrade,
                selectedCategory: element.selectedCategory,
                selectedDegree: element.selectedDegree,
              });

              this.changeHighSchoolCerti(element.CurriculumId);
            }
          });
          this.setState({ undergradDegree: underGradDegree, loading: false });
        } else if (this.props.educationHistory.length === 1) {
          const element = this.props.educationHistory[0];
          let yearOfGraduation = "";
          if (element.EndDate) {
            const date = new Date(element.EndDate);
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let year = date.getFullYear();
            if (month < 10) {
              month = "0" + month;
            }
            if (day < 10) {
              day = "0" + day;
            }
            if (year < 10) {
              year = "000" + year;
            } else if (year < 100) {
              year = "00" + year;
            } else if (year < 1000) {
              year = "0" + year;
            }
            yearOfGraduation = year + "-" + month + "-" + day;
          }
          let highSchoolName;
          let perviousUniversity;
          if (element.InstitutionId === "36") {
            highSchoolName = [{ Id: "36", value: element.InstitutionName }];
          } else {
            highSchoolName = this.state.highSchoolNameData.filter(
              (ele) => ele.Id === parseInt(element.InstitutionId)
            );
          }
          if (element.TranferedInstitutionId === "other") {
            perviousUniversity = [
              { Id: "other", value: element.TranferedInstitutionName },
            ];
          } else {
            perviousUniversity = this.state.previousUniversityData.filter(
              (ele) => ele.Id === parseInt(element.TranferedInstitutionId)
            );
          }

          this.setState({
            highSchoolCertificate: element.CurriculumId,
            endDate: yearOfGraduation || "",
            highSchoolName:
              highSchoolName && highSchoolName.length > 0
                ? highSchoolName[0].Id
                : "",
            selectedCountry: element.CountryId,
            grade: element.GradeId,
            perviousUniversity: perviousUniversity.length
              ? perviousUniversity[0].Id
              : "",
            loading: false,
            institutionName:
              highSchoolName && highSchoolName.length > 0
                ? highSchoolName[0].value
                : "",
            perviousUniversityName:
              perviousUniversity && perviousUniversity.length > 0
                ? perviousUniversity[0].value
                : "",
            previousUniversityCertificate: element.TransferredCerti,
            previousUniversityGPA: element.TransferredGPA,
            mark: element.TotalMark,
            educationGrade: element.EducationGrade,
            selectedCategory: element.selectedCategory,
            selectedDegree: element.selectedDegree,
          });

          this.changeHighSchoolCerti(element.CurriculumId);
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => console.log(err));
  }

  getSchoolGrades(val) {
    var schoolGrade = fetch(
      `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetHonorList`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ educationGradeData: res });
        if (res.length) {
          //this.setState({ educationGrade: this.props.educationGrade})
          return "";
        }
      })
      .catch((err) => console.log(err));
    //this.setState({ educationGrade: this.props.educationGrade})

    return schoolGrade;
  }

  removeUnderGradDegree(index) {
    /* This function removes the degree from the visible list, while keeping the values that are in the input boxes intact
     and also updates the state to Mains.js */
    const {
      selectedCategory,
      selectedDegree,
      highSchoolName,
      highSchoolCertificate,
      grade,
      endDate,
      selectedCountry,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      undergradDegree,
      previousUniversityCertificate,
      previousUniversityGPA,
      mark,
    } = this.state;
    const degrees = [];
    undergradDegree.forEach((element, index1) => {
      if (index1 !== index) {
        degrees.push(element);
      }
    });
    this.props.collectState("EH", {
      underGradDegree: degrees,
      highSchoolCertificate: highSchoolCertificate,
      endDate: endDate,
      highSchoolName: highSchoolName,
      selectedCategory: selectedCategory,
      selectedDegree: selectedDegree,
      selectedCountry: selectedCountry,
      grade: grade,
      mark: mark,
      perviousUniversity: perviousUniversity,
      institutionName: institutionName,
      perviousUniversityName: perviousUniversityName,
      previousUniversityGPA: previousUniversityGPA,
      previousUniversityCertificate: previousUniversityCertificate,
    });
    this.setState({ undergradDegree: degrees });
  }

  addUnderGradDegree() {
    /* This function does the following :
      1. Checks if the data is validated or not ( Required fields filled and format is correct )
      2. Adds degree and updates state in Main.js if validated.
      3. Shows an alert of error if not.
          */
    const {
      highSchoolName,
      selectedCategory,
      highSchoolCertificate,
      selectedDegree,
      grade,
      endDate,
      selectedCountry,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      previousUniversityCertificate,
      previousUniversityGPA,
      mark,
      educationGrade,
    } = this.state;
    if (
      highSchoolCertificate !== "" &&
      endDate &&
      highSchoolName !== "" &&
      selectedCountry !== "" &&
      grade &&
      mark
    ) {
      if (highSchoolName === "other" && !institutionName) {
        alert("Please fill all required fields before adding new!");
      } else if (perviousUniversity === "other" && !perviousUniversityName) {
        alert("Please fill all required fields before adding new!");
      } else if (
        perviousUniversity &&
        !previousUniversityCertificate &&
        !previousUniversityGPA
      ) {
        alert("Please fill all required fields before adding new!");
      } else {
        const degree = {
          highSchoolCertificate: highSchoolCertificate,
          endDate: endDate,
          highSchoolName: highSchoolName,
          selectedCategory: selectedCategory,
          selectedDegree: selectedDegree,
          selectedCountry: selectedCountry,
          grade: grade,
          mark: mark,
          perviousUniversity: perviousUniversity,
          institutionName: institutionName,
          perviousUniversityName: perviousUniversityName,
          previousUniversityCertificate: previousUniversityCertificate,
          previousUniversityGPA: previousUniversityGPA,
          educationGrade: educationGrade,
        };
        this.props.collectState("EH", {
          underGradDegree: [...this.state.undergradDegree, degree],
          highSchoolCertificate: "",
          endDate: "",
          highSchoolName: "",
          selectedCategory: "",
          selectedDegree: "",
          selectedCountry: "",
          grade: "",
          mark: "",
          perviousUniversity: "",
          institutionName: "",
          perviousUniversityName: "",
          previousUniversityCertificate: "",
          previousUniversityGPA: "",
          educationGrade: "",
        });
        this.setState({
          undergradDegree: [...this.state.undergradDegree, degree],
        });
        this.setState({
          highSchoolCertificate: "",
          endDate: "",
          highSchoolName: "",
          selectedCategory: "",
          selectedDegree: "",
          selectedCountry: "",
          grade: "",
          mark: "",
          perviousUniversity: "",
          institutionName: "",
          perviousUniversityName: "",
          previousUniversityCertificate: "",
          previousUniversityGPA: "",
          educationGrade: "",
        });
      }
    } else {
      alert("Please fill all required fields before adding new!");
    }
  }

  changeHighSchoolCerti(val) {
    this.setState({ highSchoolCertificate: val });
    this.getSchoolGrades(val);
  }

  renderUnderGraduate() {
    const validationError = this.props.error;
    const {
      loading,
      selectedCategory,
      undergradDegree,
      highSchoolNameData,
      highSchoolCertificateData,
      educationGradeData,
      highSchoolName,
      previousUniversityData,
      highSchoolCertificate,
      degreeData,
      selectedDegree,
      educationGrade,
      grade,
      endDate,
      selectedCountry,
      perviousUniversity,
      institutionName,
      perviousUniversityName,
      previousUniversityCertificate,
      previousUniversityGPA,
      mark,
    } = this.state;
    if (loading) {
      return <Loading />;
    }
    const visibleDetailDegree = [];
    if (undergradDegree.length > 0) {
      undergradDegree.forEach((element, index) => {
        let highSchoolName;
        if (element.highSchoolName === "36") {
          highSchoolName = [{ Id: "36", value: element.institutionName }];
        } else {
          highSchoolName = highSchoolNameData.filter(
            (ele) => ele.Id === parseInt(element.highSchoolName)
          );
        }
        const highSchoolCertiName = highSchoolCertificateData.filter(
          (ele) => ele.Id === parseInt(element.highSchoolCertificate)
        );
        visibleDetailDegree.push(
          <div className="degree-wrapper" key={index}>
            <div>
              <p>{highSchoolName.length ? highSchoolName[0].value : ""}</p>
              <p>
                {highSchoolCertiName.length ? highSchoolCertiName[0].value : ""}
              </p>
            </div>
            <button onClick={this.removeUnderGradDegree.bind(this, index)}>
              x
            </button>
          </div>
        );
      });
    }
    if (loading) {
      return <Loading />;
    }
    return (
      <div className="education-his-wrapper">
        <div className="education-his-box">
          <div>
            <InputRow
              name="select"
              rowName="University"
              hover="Please insert the name of the university you attended. أدخل اسم الجامعة التي درست فيها . "
              required="*"
              errMsg={
                validationError.highSchoolName
                  ? validationError.highSchoolName
                  : ""
              }
              //data={highSchoolNameData.length > 0 ? [...highSchoolNameData, { Id: 'other', value: 'Other' }] : highSchoolNameData}
              data={highSchoolNameData}
              value={highSchoolName}
              onChange={(val) => {
                if (val === "1208") {
                  this.props.collectState("EH", {
                    selectedDegree: selectedDegree,
                    selectedCategory: selectedCategory,
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade: educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: val,
                    selectedCountry: selectedCountry,
                    perviousUniversity: perviousUniversity,
                    institutionName: "",
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCertificate:
                      previousUniversityCertificate,
                    previousUniversityGPA: previousUniversityGPA,
                  });
                  this.setState({ highSchoolName: val, institutionName: "" });
                } else {
                  const hName = highSchoolNameData.filter(
                    (ele) => parseInt(ele.Id) === parseInt(val)
                  );
                  this.props.collectState("EH", {
                    selectedDegree: selectedDegree,
                    selectedCategory: selectedCategory,
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade: educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: val,
                    selectedCountry: selectedCountry,
                    perviousUniversity: perviousUniversity,
                    institutionName:
                      hName && hName.length > 0 ? hName[0].value : "",
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCertificate:
                      previousUniversityCertificate,
                    previousUniversityGPA: previousUniversityGPA,
                  });
                  this.setState({
                    highSchoolName: val,
                    institutionName:
                      hName && hName.length > 0 ? hName[0].value : "",
                  });
                }
              }}
            />
            {highSchoolName === "1208" ||
            highSchoolName === "OTHER" ||
            highSchoolName === 1208 ? (
              <InputRow
                name="text"
                rowName="University"
                required="*"
                errMsg={
                  validationError.institutionName
                    ? validationError.institutionName
                    : ""
                }
                value={institutionName}
                onChange={(val) => {
                  this.setState({ institutionName: val });
                  this.props.collectState("EH", {
                    selectedDegree: selectedDegree,
                    selectedCategory: selectedCategory,
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    educationGrade: educationGrade,
                    grade: grade,
                    mark: mark,
                    endDate: endDate,
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    perviousUniversity: perviousUniversity,
                    institutionName: val,
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCertificate:
                      previousUniversityCertificate,
                    previousUniversityGPA: previousUniversityGPA,
                  });
                }}
              />
            ) : null}

            <InputRow
              name="select"
              rowName="Degree"
              hover="Please select the degree you have earned . يرجى اختيار الشهادة التى حصلت عليها."
              required="*"
              errMsg={
                validationError.educationDegree
                  ? validationError.educationDegree
                  : ""
              }
              data={degreeData}
              value={selectedDegree}
              onChange={(val) => {
                this.setState({ selectedDegree: val });
                this.props.collectState("EH", {
                  selectedDegree: val,
                  selectedCategory: selectedCategory,
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: val,
                  educationGrade: educationGrade,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCertificate: previousUniversityCertificate,
                  previousUniversityGPA: previousUniversityGPA,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Major"
              hover="Please select the Major you have earned . يرجى اختيار الشهادة التى حصلت عليها."
              required="*"
              errMsg={
                validationError.highSchoolCertificate
                  ? validationError.highSchoolCertificate
                  : ""
              }
              data={highSchoolCertificateData}
              value={highSchoolCertificate}
              onChange={(val) => {
                this.changeHighSchoolCerti(val);
                this.props.collectState("EH", {
                  selectedDegree: selectedDegree,
                  selectedCategory: selectedCategory,
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: val,
                  educationGrade: educationGrade,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCertificate: previousUniversityCertificate,
                  previousUniversityGPA: previousUniversityGPA,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Grade"
              required="*"
              errMsg={
                validationError.educationGrade
                  ? validationError.educationGrade
                  : ""
              }
              data={educationGradeData}
              value={educationGrade}
              onChange={(val) => {
                this.setState({ educationGrade: val });
                this.props.collectState("EH", {
                  selectedDegree: selectedDegree,
                  selectedCategory: selectedCategory,
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: highSchoolCertificate,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCertificate: previousUniversityCertificate,
                  previousUniversityGPA: previousUniversityGPA,
                  educationGrade: val,
                });
              }}
            />

            <InputRow
              rowName="Category"
              name="select"
              value={selectedCategory}
              data={[
                { Id: "BUS", value: "Business" },
                { Id: "N-Bus", value: "Non Business" },
              ]}
              required="*"
              errMsg={
                validationError.educationCategory
                  ? validationError.educationCategory
                  : ""
              }
              onChange={(val) => {
                this.setState({ selectedCategory: val });
                this.props.collectState("EH", {
                  selectedDegree: selectedDegree,
                  selectedCategory: val,
                  underGradDegree: undergradDegree,
                  highSchoolCertificate: highSchoolCertificate,
                  grade: grade,
                  mark: mark,
                  endDate: endDate,
                  highSchoolName: highSchoolName,
                  selectedCountry: selectedCountry,
                  perviousUniversity: perviousUniversity,
                  institutionName: institutionName,
                  perviousUniversityName: perviousUniversityName,
                  previousUniversityCertificate: previousUniversityCertificate,
                  previousUniversityGPA: previousUniversityGPA,
                  educationGrade: educationGrade,
                });
              }}
            />

            {/* <InputRow
              name="date"
              required="*"
              errMsg={validationError.endDate ? validationError.endDate : ""}
              hover="Please insert the date of your High School Graduation,If you cannot remember the exact day, you can choose the 1st day of the selected month.في أي سنة تخرجت من المدرسة الثانوية ؟إذا كنت لا تستطيع تذكر اليوم بالضبط ضع اليوم الأول من الشهر."
              value={endDate}
              rowName="Graduation date"
              onChange={(val) => {
                const dob = new Date(val);
                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999) {
                    this.setState({ endDate: val });
                    this.props.collectState("EH", {
                      underGradDegree: undergradDegree,
                      highSchoolCertificate: highSchoolCertificate,
                      grade: grade,
                      mark: mark,
                      endDate: val,
                      highSchoolName: highSchoolName,
                      selectedCountry: selectedCountry,
                      perviousUniversity: perviousUniversity,
                      institutionName: institutionName,
                      perviousUniversityName: perviousUniversityName,
                      previousUniversityCertificate:
                        previousUniversityCertificate,
                      previousUniversityGPA: previousUniversityGPA,
                      educationGrade: educationGrade,
                    });
                  }
                } else {
                  this.setState({ endDate: "" });
                  this.props.collectState("EH", {
                    underGradDegree: undergradDegree,
                    highSchoolCertificate: highSchoolCertificate,
                    grade: grade,
                    mark: mark,
                    endDate: "",
                    highSchoolName: highSchoolName,
                    selectedCountry: selectedCountry,
                    perviousUniversity: perviousUniversity,
                    institutionName: institutionName,
                    perviousUniversityName: perviousUniversityName,
                    previousUniversityCertificate:
                      previousUniversityCertificate,
                    previousUniversityGPA: previousUniversityGPA,
                    educationGrade: educationGrade,
                  });
                }
              }}
            /> */}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error } = this.state;
    if (loading) {
      return <Loading />;
    }

    return (
      <div>
        <p style={{ color: "red" }}>{error}</p>
        {this.renderUnderGraduate()}
        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}
EducationHistoryUndergraduate.propTypes = {
  countryData: PropTypes.array.isRequired,
  program: PropTypes.number.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  educationHistory: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
